module.exports = {
    props: ['user', 'team']
};



// WEBPACK FOOTER //
// ./spark/resources/assets/js/settings/teams/team-profile.js